import gql from 'graphql-tag'

export default gql`query getPartners {
  getPartners {
		id
		name
		logo
		url
		updated_at
	}
}`



// WEBPACK FOOTER //
// ./src/apollo/graphql/partner/getPartners.js